export default "__VITE_ASSET__CRmtSiXX__"